import gql from 'graphql-tag';
import { parseToMutationRequest } from '../../../utils/utils';

export default data => {
  const dataModify = parseToMutationRequest(data, [
    'index',
    'status',
    'serviceType',
    'tariff',
    'direction',
    'tierMax',
    'tierMin',
    'contractCapacity',
    'commitmentBase',
    'rentalAmount',
    'exchangeRate',
    'trafficType',
  ]);
  const modifyConfigOperatorMap = `modifyConfigOperatorMap(input: ${dataModify})`;
  return gql`
  mutation {
    ${modifyConfigOperatorMap} {
      id
    }
  }
`;
};
